<div class="row">
  <div class="col-md-12">
    <h2>Manage Subscriptions</h2>
    <div *ngIf="!isAdmin && businesses.length > 0" class="business-subscription-selector mb-4">
      <button
        *ngFor="let business of businesses"
        type="button"
        class="business-selector"
        [class.active]="selectedBusiness?.id === business.id"
        (click)="selectBusiness(business)">
        <span>{{ business.Name }}</span>
        <small>{{ business.Subscription || isLegacySubscriptionBusiness(business) ? 'Subscribed' : 'No subscription' }}</small>
      </button>
    </div>
    <h3 *ngIf="!isAdmin && selectedBusiness" class="mb-2">{{ selectedBusiness.Name }}</h3>
    <p>
      {{
        subscriptionDetails
          ? "View and manage your subscriptions"
          : "You have no active subscriptions"
      }}
    </p>
    <p *ngIf="subscriptionDetails">
      Any failure of payment will result in the account getting terminated
      unless specific agreements have been arranged.
      <a target="_blank" href="https://www.advibe.co.za/terms-and-conditions"
        >Terms of Service</a
      >
    </p>

    <div class="col-md-12 d-flex justify-content-center flex-column mat-card">
      <div *ngIf="subscriptionDetails" class="row justify-content-center">
        <div class="h-100 w-100 form-check relative scrollable">
          <div class="d-flex justify-content-between">
            <h2 class="m-0">
              {{ subscriptionDetails.amount | currency: "R" }} per month
            </h2>
          </div>
          <p>Start Date: {{ subscriptionDetails.billing_date }}</p>
          <p>Expiry Date: {{ subscriptionDetails.expiry_date }}</p>
          <p>
            <fa-icon [icon]="faCheckCircle"></fa-icon
            >{{
              paymentConfirmed ? "Confirmed" : "Pending payment confirmation"
            }}
          </p>
          <!-- FORM -->
          <form
            [formGroup]="orderForm"
            (ngSubmit)="updateSubscription()"
          >
            <div class="row d-flex justify-content-center m-0">
              <div
                *ngFor="let package of packages; index as n"
                class="col-md-4 p-3"
                (click)="selectSubscriptionPackage(package)"
              >
                <mat-card
                  class="h-100 form-check relative text-center selected-option mb-3 p-0"
                >
                  <h2 class="m-3">{{ package.title }}</h2>
                  <h3 class="mat-title">
                    {{ package.priceInRand | currency: "R" }}
                    {{ package.paymentInterval }}
                  </h3>
                  <p>
                    {{ package.description }}
                  </p>
                  <fa-icon
                    *ngIf="
                      orderForm.controls.package.value === package.priceInRand
                    "
                    class="text-white absoluteRightTop"
                    [icon]="faCheckCircle"
                  ></fa-icon>
                </mat-card>
              </div>
            </div>
            <!-- ADD ON FORM -->
            <!-- <div class="row d-flex justify-content-center m-0">
              <h1>Add-Ons</h1>
              <div
                *ngFor="let package of addonPackages; index as n"
                class="col-md-12 p-3"
              >
                <mat-card
                  class="h-100 mb-3 p-0 text-black"
                  style="cursor: pointer;"
                  (click)="cb.checked = !cb.checked; handleAddOnChange({checked: cb.checked}, package)"
                >
                  <div class="d-flex align-items-center">
                    <mat-checkbox #cb (click)="$event.stopPropagation()" (change)="handleAddOnChange($event,package)" class="ml-2"></mat-checkbox>
                    <div class="ml-2">
                      <h2 class="m-0 text-primary">{{ package.title }}</h2>
                      <h3 class="m-0">
                        {{ package.description }}
                      </h3>
                      <h3 class="m-0">
                        {{ package.priceInRand | currency: "R" }}
                      </h3>
                      <fa-icon
                        *ngIf="
                          orderForm.controls.package.value ===
                          package.priceInRand
                        "
                        class="text-white absoluteRightTop"
                        [icon]="faCheckCircle"
                      ></fa-icon>
                    </div>
                  </div>
                </mat-card>
              </div>
            </div> -->
            <!-- ADD ON FORM END -->
            <div class="d-flex flex-column mt-3">
              <div class="mb-3">
                <label for="name" class="form-label">Name</label>
                <input
                  formControlName="name"
                  type="text"
                  class="form-control"
                  id="name"
                />
                <p
                  *ngIf="
                    orderForm.controls.name.errors
                      ? orderForm.controls.name.errors['required']
                      : ''
                  "
                >
                  Required
                </p>
              </div>
              <div class="mb-3">
                <label for="surname" class="form-label">Surname</label>
                <input
                  formControlName="surname"
                  type="text"
                  class="form-control"
                  id="surname"
                />
              </div>
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input
                  formControlName="email"
                  type="email"
                  class="form-control"
                  id="email"
                />
              </div>
              <div class="mb-3">
                <label for="number" class="form-label">Mobile</label>
                <input
                  formControlName="contactNumber"
                  type="string"
                  class="form-control"
                  id="number"
                />
              </div>
              <div class="mb-3">
                <label for="address" class="form-label">Address</label>
                <input
                  formControlName="address"
                  type="text"
                  class="form-control"
                  id="address"
                />
              </div>
              <mat-form-field class="mb-3">
                <mat-label for="billingDate" class="form-label"
                  >Start date</mat-label
                >
                <input matInput formControlName="billingDate" type="text" />
                <mat-hint>dd/mm/yyyy</mat-hint>
              </mat-form-field>

              <mat-form-field class="mb-3">
                <mat-label for="expiryDate" class="form-label"
                  >Expiry date</mat-label
                >
                <input matInput formControlName="expiryDate" type="text" />
                <mat-hint>dd/mm/yyyy</mat-hint>
              </mat-form-field>
            </div>
            <div>
              <p>Your annual recurring total will be: <b>{{orderForm.controls['package'].value | currency: 'R'}}</b></p>
              
            </div>
            <div class="row m-3">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                class="text-white flex-1"
              >
                Save
              </button>
            </div>
          </form>
          <!-- FORM END -->
          <button
            *ngIf="subscriptionDetails && !cancelationRequest"
            (click)="openCancelSubscriptionDialog()"
            mat-raised-button
            class="m-3"
          >
            Cancel Subscription
          </button>
          <ng-container *ngIf="cancelationRequest">
            <p class="text-danger">
              Cancelation requested with reason:
              <i>{{ cancelationRequest.reason }}</i>
            </p>
            <button
              (click)="deleteCancelationRequest()"
              mat-raised-button
              class="m-3"
            >
              Cancel request
            </button>
          </ng-container>
        </div>
      </div>
      <button
        *ngIf="!subscriptionDetails && selectedBusiness"
        mat-raised-button
        class="text-white m-3"
        color="primary"
        (click)="completePayment()"
      >
        Complete payment
      </button>
      <button
        *ngIf="!isAdmin && businesses.length === 0"
        mat-raised-button
        class="text-white m-3"
        color="primary"
        routerLink="../../onboarding">
        List My Business
      </button>
    </div>
  </div>
</div>
